/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lazy_Funny_Ant_AbsorbInputs */

const fr_lazy_funny_ant_absorb = /** @type {(inputs: Lazy_Funny_Ant_AbsorbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiert une action`)
};

/**

* @param {Lazy_Funny_Ant_AbsorbInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const lazy_funny_ant_absorb = /** @type {((inputs?: Lazy_Funny_Ant_AbsorbInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lazy_Funny_Ant_AbsorbInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_lazy_funny_ant_absorb(inputs)
});